import React, { Component } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Stack,
} from "@mui/material";

// Ícones MUI para as avaliações
import StarIcon from "@mui/icons-material/Star";

class Depoimentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depoimentos: [
        {
          quote:
            "Eu perdia horas respondendo mensagens e calculando frete à mão. Com o catálogo digital do FazPedido, o cliente escolhe, calcula o CEP e finaliza tudo sozinho. Minhas vendas diárias dobraram.",
          tag: "Vendas 2x Mais Rápidas",
          name: "Juliana Santos",
          role: "Proprietária - Loja de Moda & Acessórios - SP",
          image: "https://images.unsplash.com/photo-1596815064285-45ed8a1c9360?auto=format&fit=crop&w=300&q=80",
        },
        {
          quote:
            "A integração da minha loja física com a internet salvou meu estoque. Quando vendo um produto no caixa (PDV), ele atualiza o sistema na mesma hora. Zeramos os furos de inventário.",
          tag: "Estoque 100% Sincronizado",
          name: "Roberto Almeida",
          role: "Gerente - Eletrônicos & Variedades - RJ",
          image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=300&q=80",
        },
        {
          quote:
            "Parei de pagar taxas abusivas de 20% em marketplaces que comiam todo o meu lucro. Criei meu link próprio, divulguei no Instagram e agora o dinheiro das vendas é 100% meu.",
          tag: "Zero Comissões Abusivas",
          name: "Mariana Costa",
          role: "Empreendedora - Casa & Decoração - MG",
          image: "https://images.unsplash.com/photo-1520813792240-542bc839d374?auto=format&fit=crop&w=300&q=80",
        },
      ],
    };
  }

  render() {
    return (
      <Box
        component="section"
        id="depoimentos"
        sx={{ bgcolor: "#ffffff", py: { xs: 6, sm: 10 } }}
      >
        <Container maxWidth="xl">
          {/* Cabeçalho da Seção */}
          <Box sx={{ mx: "auto", maxWidth: "700px", textAlign: "center", mb: 8 }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontWeight: 800,
                color: "#1E1B4B",
                fontSize: { xs: "2rem", sm: "2.5rem", lg: "2.75rem" },
                mb: 2,
                lineHeight: 1.2,
              }}
            >
              Lojistas Satisfeitos, Resultados Reais
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#464467",
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 1.6,
              }}
            >
              Empreendedores que confiaram no <strong>FazPedido</strong> para digitalizar suas operações, fugir de taxas abusivas e ver as vendas crescerem.
            </Typography>
          </Box>

          {/* Grade de Depoimentos */}
          <Grid container spacing={4}>
            {this.state.depoimentos.map((depoimento, index) => (
              <Grid size={{ xs: 12, md: 4 }} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "20px",
                    border: "1px solid #DAD7FE",
                    bgcolor: "#F4F2FF",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 12px 28px -8px rgba(124, 58, 237, 0.2)",
                      borderColor: "#7C3AED",
                    },
                  }}
                >
                  <CardContent sx={{ p: 4, display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Estrelas de Avaliação */}
                    <Stack direction="row" spacing={0.5} sx={{ mb: 2.5 }}>
                      {[...Array(5)].map((_, i) => (
                        <StarIcon key={i} sx={{ color: "#7C3AED", fontSize: 18 }} />
                      ))}
                    </Stack>

                    {/* Citação */}
                    <Typography
                      component="blockquote"
                      variant="body2"
                      sx={{
                        color: "#464467",
                        fontSize: "0.95rem",
                        fontStyle: "italic",
                        lineHeight: 1.6,
                        flexGrow: 1,
                        mb: 3,
                      }}
                    >
                      "{depoimento.quote}"
                    </Typography>

                    {/* Tag de Destaque */}
                    <Box sx={{ mb: 3 }}>
                      <Chip
                        label={depoimento.tag}
                        size="small"
                        sx={{
                          bgcolor: "#ffffff",
                          color: "#7C3AED",
                          fontWeight: 700,
                          fontSize: "0.75rem",
                          border: "1px solid #DAD7FE",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                        }}
                      />
                    </Box>

                    {/* Informações do Cliente */}
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      sx={{
                        borderTop: "1px solid #E5E3FB",
                        pt: 2.5,
                      }}
                    >
                      <Avatar
                        src={depoimento.image}
                        alt={`Foto de ${depoimento.name}`}
                        sx={{ width: 48, height: 48 }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "https://placehold.co/120x120/7C3AED/ffffff?text=F+P";
                        }}
                      />
                      <Box>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: "#1F1B2E", fontSize: "0.95rem" }}
                        >
                          {depoimento.name}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "#6B6790", fontSize: "0.8rem", display: "block" }}
                        >
                          {depoimento.role}
                        </Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default Depoimentos;